const MENU_UI_ACTIONS = {
  view_dashboard: {
    name: 'view_dashboard',
    title: 'Dashboard',
  },
  view_geo_config_menu: {
    name: 'view_geo_config_menu',
    title: 'Geo Configuration',
  },
  view_circles_list: {
    name: 'view_circles_list',
    title: 'Circle',
  },
  view_clusters_list: {
    name: 'view_clusters_list',
    title: 'Cluster'
  },
  view_states_list: {
    name: 'view_states_list',
    title: 'State',
  },
  view_pincodes_list: {
    name: 'view_pincodes_list',
    title: 'PIN Code / Area'
  },
  view_users_list_menu: {
    name: 'view_users_list_menu',
    title: 'User List',
  },
  view_customers_list: {
    name: 'view_customers_list',
    title: 'Customers',
  },
  view_distributors_list: {
    name: 'view_distributors_list',
    title: 'Distributors',
  },
  view_fleet_owners_list: {
    name: 'view_fleet_owners_list',
    title: 'Fleet Owners'
  },
  view_head_users_list: {
    name: 'view_head_users_list',
    title: 'Manage Users'
  },
  view_inventory_menu: {
    name: 'view_inventory_menu',
    title: 'Inventory',
  },
  view_batteries_listing: {
    name: 'view_batteries_listing',
    title: 'Battery'
  },
  view_bikes_listing: {
    name: 'view_bikes_listing',
    title: 'Rental Bike Types'
  },
  view_warehouses_listing: {
    name: 'view_warehouses_listing',
    title: 'Warehouse'
  },
  view_battery_models_listing: {
    name: 'view_battery_models_listing',
    title: 'Battery Model'
  },
  view_battery_transactions_list: {
    name: 'view_battery_transactions_list',
    title: 'Battery Transactions'
  },
  view_charging_stations_menu: {
    name: 'view_charging_stations_menu',
    title: 'Charging Station'
  },
  view_charging_stations_listing: {
    name: 'view_charging_stations_listing',
    title: 'Charging Stations'
  },
  view_cs_diagnostics_menu_page: {
    name: 'view_cs_diagnostics_menu_page',
    title: 'Diagnostics'
  },
  view_cs_version_update_menu_page: {
    name: 'view_cs_version_update_menu_page',
    title: 'Version Update'
  },
  view_partners_reimbursement_menu: {
    name: 'view_partners_reimbursement_menu',
    title: 'Partner Reimbursement',
  },
  view_earnings_list: {
    name: 'view_earnings_list',
    title: 'Earnings',
  },
  view_partner_billings_listing: {
    name: 'view_partner_billings_listing',
    title: 'Partner Billings',
  },
  view_electricity_menu: {
    name: 'view_electricity_menu',
    title: 'Electricity',
  },
  view_electricity_claims_list: {
    name: 'view_electricity_claims_list',
    title: 'Claims',
  },
  view_electricity_configurations_list: {
    name: 'view_electricity_configurations_list',
    title: 'Configuration',
  },
  view_electricity_providers_list: {
    name: 'view_electricity_providers_list',
    title: 'Service Provider',
  },
  view_pricings_menu: {
    name: 'view_pricings_menu',
    title: 'Pricing',
  },
  view_offers_listing: {
    name: 'view_offers_listing',
    title: 'Offers',
  },
  view_schemes_listing: {
    name: 'view_schemes_listing',
    title: 'Schemes'
  },
  view_security_amount_listing: {
    name: 'view_security_amount_listing',
    title: 'Security Amount'
  },
  view_authorization_menu: {
    name: 'view_authorization_menu',
    title: 'Authorization',
  },
  view_auth_permissions_editor: {
    name: 'view_auth_permissions_editor',
    title: 'Permissions',
  },
  view_crm_users_list: {
    name: 'view_crm_users_list',
    title: 'CRM Users',
  },
  view_work_orders_menu: {
    name: 'view_work_orders_menu',
    title: 'Work Orders',
  },
  view_work_orders_list: {
    name: 'view_work_orders_list',
    title: 'Listing',
  },
  view_addons_list: {
    name: 'view_addons_list',
    title: 'Addons',
  },
  view_offer_addons_list: {
    name: 'view_offer_addons_list',
    title: 'Offer Addons',
  },
  view_service_centers_list: {
    name: 'view_service_centers_list',
    title: 'Service Centers',
  },
  view_complaint_categories_list: {
    name: 'view_complaint_categories_list',
    title: 'Categories'
  },
  view_reports_menu: {
    name: 'view_reports_menu',
    title: 'Reports',
  },
  view_tally_transactions_list: {
    name: 'view_tally_transactions_list',
    title: 'Tally Transactions',
  },
  view_transactions_menu: {
    name: 'view_transactions_menu',
    title: 'Transactions',
  },
  view_wallet_transactions_list: {
    name: 'view_wallet_transactions_list',
    title: 'Wallet Transactions',
  },
  view_general_reports_listing: {
    name: 'view_general_reports_listing',
    title: 'General Reports',
  },
  view_wallet_cashbacks_list: {
    name: 'view_wallet_cashbacks_list',
    title: 'Wallet Cashbacks',
  },
  view_uploads: {
    name: 'view_uploads',
    title: 'Uploads',
  },
  view_uploader_history_listing: {
    name: 'view_uploader_history_listing',
    title: 'History',
  },
  view_rfids_list: {
    name: 'view_rfids_list',
    title: 'Voltup ID Cards',
  },
  view_challans_list: {
    name: 'view_challans_list',
    title: 'Challans',
  },
  view_upload_files_menu: {
    name: 'view_upload_files_menu',
    title: 'Upload Files'
  },
  view_vehicles_menu: {
    name: 'view_vehicles_menu',
    title: 'Vehicles'
  },
  view_vehicles_list: {
    name: 'view_vehicles_list',
    title: 'Listing',
  },
  view_vehicle_types_list: {
    name: 'view_vehicle_types_list',
    title: 'Vehicle Types',
  },
  view_vehicle_inspection_items_list: {
    name: 'view_vehicle_inspection_items_list',
    title: 'Inspection Items',
  },
  view_rentals_menu: {
    name: 'view_rentals_menu',
    title: 'Rentals',
  },
  view_rental_bookings_list: {
    name: 'view_rental_bookings_list',
    title: 'Bookings',
  },
  view_asset_earnings_config_list: {
    name: 'view_asset_earnings_config_list',
    title: 'Earnings Config',
  },
  view_rental_customers_list: {
    name: 'view_rental_customers_list',
    title: 'Rental Customers',
  },
  view_leads_menu: {
    name: 'view_leads_menu',
    title: 'Leads'
  },
  view_leads_listing: {
    name: 'view_leads_listing',
    title: 'Listing'
  },
  view_leads_earning_configs_listing: {
    name: 'view_leads_earning_configs_listing',
    title: 'Earning Config'
  },
  view_service_type_mapping_menu: {
    name: 'view_service_type_mapping_menu',
    title: 'Service Type Mapping'
  },
  view_voltup_allocation_kit_menu: {
    name: 'view_voltup_allocation_kit_menu',
    title: 'VoltUp Allocation Kit'
  },
  view_voltup_allocation_kit_list: {
    name: 'view_voltup_allocation_kit_list',
    title: 'VoltUp Allocation Kit'
  },
  view_voltup_allocation_kit_reports_list: {
    name: 'view_voltup_allocation_kit_reports_list',
    title: 'VAK Reports'
  },
  view_voltup_allocation_kit_transactions_list: {
    name: 'view_voltup_allocation_kit_transactions_list',
    title: 'VAK Transactions'
  },
  view_charging_zones_map_menu: {
    name: 'view_charging_zones_map_menu',
    title: 'Charging Zones Map'
  },
  view_search_user_menu: {
    name: 'view_search_user_menu',
    title: 'Search'
  },
  view_search_user_page: {
    name: 'view_search_user_page',
    title: 'Search User'
  },
  view_support_menu: {
    name: 'view_support_menu',
    title: 'Support'
  },
  view_transaction_orders_menu: {
    name: 'view_transaction_orders_menu',
    title: 'Transaction Orders'
  },
  view_operations_menu: {
    name: 'view_operations_menu',
    title: 'Operations'
  }
}

export default MENU_UI_ACTIONS;
